// extracted by mini-css-extract-plugin
export default {"UploadTab":"UploadTab_UploadTab__62z5B"};